import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API } from "@/lib/api";

const pretty = (g) => (g === "sci-fi" ? "Sci-Fi" : g.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()));

// Master genre list (TMDb standard + ReelVault custom) served by the backend.
export const useGenres = () => {
  const { data } = useQuery({
    queryKey: ["genre-master-list"],
    queryFn: async () => (await axios.get(`${API}/genres`)).data.genres,
    staleTime: 60 * 60 * 1000,
  });
  const list = data || [];
  const map = Object.fromEntries(list.map((g) => [g.slug, g.label]));
  return {
    genres: list.map((g) => g.slug),
    groups: list,
    label: (g) => map[g] || (g ? pretty(g) : ""),
  };
};

export const GenreOptions = ({ groups }) => (
  <>
    <optgroup label="Standard genres">
      {groups.filter((g) => g.group === "standard").map((g) => <option key={g.slug} value={g.slug}>{g.label}</option>)}
    </optgroup>
    <optgroup label="ReelVault categories">
      {groups.filter((g) => g.group === "custom").map((g) => <option key={g.slug} value={g.slug}>{g.label}</option>)}
    </optgroup>
  </>
);
